import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  mapWorkspacePermissionRequestResponseInstance,
} from '@toolify/client/src/modules/api/singletons/mapWorkspacePermissionRequestResponseInstance'
import {
  INotificationPayloadMapperStrategy,
} from '@toolify/client/src/modules/api/notificationPayloadMappers/types/INotificationPayloadMapperStrategy'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'

type T = NotificationType.WorkspacePermissionRequestPending

export const WorkspacePermissionRequestPendingNotificationPayloadMapperStrategy: INotificationPayloadMapperStrategy<T> = {
  mapPayload(payload) {
    return {
      ...payload,
      workspacePermissionRequest: mapWorkspacePermissionRequestResponseInstance(payload.workspacePermissionRequest),
      viaEntity: payload.viaEntity ? mapResponseEntity(payload.viaEntity) : null,
    }
  },
}
